export default __webpack_public_path__ + "static/media/ambient-bright-green-yellow.0094e79d.jpg";